<template>
    <div class="custom-modal show-custom-modal" @click="closeModal()">
        <div class="custom-modal-window" @click.stop>

            <div class="btn-close" @click="closeModal()"></div>

            <div class="custom-modal-body">

                <div :class="{ 'd-none' : fetcher.initialized }">
                    <div class="container-fluid">
                        <div class="placeholder-glow w-100">
                            <span class="placeholder bg-info col-18 mb-3 rounded-2" style="height: 34px;"></span>
                            <span class="placeholder bg-info col-24 mb-8 rounded-2" style="height: 48px;"></span>
                            <span class="placeholder bg-info col-18 mb-5 rounded-2" style="height: 45px;"></span>
                            <span class="placeholder bg-info col-18 mb-5 rounded-2" style="height: 45px;"></span>
                        </div>
                    </div>
                </div>

                <div v-if="fetcher.initialized">

                    <div class="container-fluid">

                        <h2><span v-if="address.co">{{ address.co }},</span> {{ address.street }}, {{ address.city }}</h2>
                        <p class="mb-8">
                            {{ title }}.
                        </p>

                        <router-link tag="div" class="address-list-item" :key="'lclinic'+index" :to="{name: 'modal-clinic', params: {clinic: clinic.id}}" v-for="(clinic, index) in clinics">

                            <div class="d-flex" v-if="clinic.checkbox_multiple_clinics || clinic.practitioners.length > 1">
                                <div>
                                    <div class="portrait-wrapper"></div>
                                </div>
                                <div class="pt-1">
                                    <h4 class="mb-1 text-primary">{{ clinic.card_name_clinic }}</h4>
                                    <span v-if="clinic.survey_score" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                                    <span v-if="clinic.is_new && !clinic.survey_score" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                                    <div style="color:#666;"><span :key="'rm'+practitioner.id" v-for="(practitioner, index2) in clinic.practitioners" v-if="practitioner.is_clinic != 1"><span v-if="index2 != 0">, </span>{{ practitioner.name }}</span></div>
                                </div>

                            </div>

                            <div class="d-flex" v-else>
                                <div>
                                    <div class="portrait-wrapper" :key="'pw'+practitioner.id" v-for="practitioner in clinic.practitioners" v-if="clinic.practitioners.length < 2">
                                        <img :src="practitioner.thumb_url" class="portrait" v-if="practitioner.thumb_url" />
                                    </div>
                                    <div class="portrait-wrapper" v-else></div>
                                </div>
                                <div class="pt-1" :key="'rs'+practitioner.id" v-for="practitioner in clinic.practitioners">
                                    <h4 class="mb-1 text-primary">{{ practitioner.name }}</h4>

                                    <span v-if="clinic.survey_score" style="font-weight: 500;" class="me-2"><img src="/images/card/review-heart.svg" style="width: 16px; margin-right: 6px; margin-top: -3px;">{{ clinic.survey_score}}</span>
                                    <span v-if="clinic.is_new && !clinic.survey_score" class="badge badge-sm bg-secondary me-1" style="transform: translateY(-2px);">Ny</span>
                                    <span style="color:#666;">{{ clinic.card_name_clinic }}</span>
                                </div>

                            </div>
                        </router-link>

                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script>
import modaler from '../../../shared/mixins/modaler'
import fetcher from '../../../shared/mixins/fetcher'
import { mapState } from 'pinia'
import { useBookingStore } from '../../stores/bookingStore'

export default {

    mixins: [
        modaler,
        fetcher
    ],

    data () {
        return {
            address: null,
            clinics: [],
            fetcher: {
                autoFill: [
                    'address',
                    'clinics'
                ]
            }
        }
    },

    computed: {
        ...mapState(useBookingStore, {
            productArea: state => state.productArea
        }),

        fetcherUrl () {
            return '/addresses/' + this.$route.params.address
        },

        fetcherParams () {
            return {
                params: {
                    productArea: this.productArea
                }
            }
        },

        title () {
            if (this.productArea === 2) {
                return 'Välj personlig tränare'
            }

            return 'Välj massör'
        }

    },

    methods: {

        closeModal () {
            this.$router.push({ name: this.$route.meta.closeTo })
        }

    }
}
</script>
